import type { DocumentNode } from "graphql";

import { buildOverlayTwinMap } from "./overlayMutationInventory";

const OVERLAY_TWINS = buildOverlayTwinMap();

/** Live → *WithOption twin. C5 stays: twins remain, pairing does not leak. */
export const overlayTwinFor = (
  liveMutation: DocumentNode
): DocumentNode | undefined => OVERLAY_TWINS.get(liveMutation);
